var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useEffect, useState } from 'react';
var listeners = new Map();
var timeoutHandler = 0;
var elapsedMsToDateTime = function (millis) {
    var seconds = (millis < 0 ? 0 : millis) / 1000;
    var m = Math.floor(seconds / 60);
    var h = Math.floor(m / 60);
    var d = Math.floor(h / 24);
    return {
        days: d,
        hours: h % 24,
        minutes: m % 60,
        seconds: Math.floor(seconds % 60),
    };
};
var handler = function () {
    for (var _i = 0, _a = Array.from(listeners.keys()); _i < _a.length; _i++) {
        var dateTill = _a[_i];
        var dateTimeObj = elapsedMsToDateTime(dateTill - Date.now());
        // small optimization: Timers don't need to be updated when they don't show seconds
        if (dateTimeObj.days > 0 && dateTimeObj.seconds > 0 && dateTimeObj.seconds < 59) {
            // eslint-disable-next-line no-continue
            continue;
        }
        for (var _b = 0, _c = listeners.get(dateTill) || []; _b < _c.length; _b++) {
            var callback = _c[_b];
            callback(dateTimeObj);
        }
    }
    timeoutHandler = setTimeout(handler, 1000);
};
export var useCampaignTimer = function (dateTill, countdownCallback) {
    var _a = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    }), remainingTime = _a[0], setRemainingTime = _a[1];
    if (timeoutHandler === 0) {
        timeoutHandler = setTimeout(handler, 1000);
    }
    var callback = useCallback(function (dateObj) {
        setRemainingTime(dateObj);
        if (dateObj.days === 0 &&
            dateObj.hours === 0 &&
            dateObj.minutes === 0 &&
            dateObj.seconds === 0) {
            listeners.delete(dateTill);
            if (countdownCallback) {
                countdownCallback();
            }
        }
    }, [countdownCallback, dateTill]);
    useEffect(function () {
        var dateTimeObj = elapsedMsToDateTime(dateTill - Date.now());
        setRemainingTime(dateTimeObj);
        listeners.set(dateTill, __spreadArray(__spreadArray([], (listeners.get(dateTill) || []), true), [callback], false));
        return function () {
            var callbacks = listeners.get(dateTill);
            callbacks === null || callbacks === void 0 ? void 0 : callbacks.splice(callbacks.indexOf(callback), 1);
        };
    }, [callback, dateTill]);
    return remainingTime;
};
